import React, { Component } from "react";
import { IFrame } from './iframe'
import WeatherPreview from './index'
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";

const WeatherIframeComp = (porps) => (
    <IFrame>
        <link rel="stylesheet" href={toAbsoluteUrl("/css/weather.css")} />
        <link rel="stylesheet" href={toAbsoluteUrl("/css/inter-fonts.css")} />
        <WeatherPreview {...porps} />
    </IFrame>
)
export default WeatherIframeComp;